<template>
  <div class="type-wide-a terms_layer showing">
    <div class="layer_section-container">
      <slot />
      <div class="align-box size-auto">
        <button
          type="button"
          class="btn-modal_close"
          @click="onDispose"
        >
          닫기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupTerms',
  methods: {
    onDispose() {
      this.$emit('dispose', 'get out!');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modal-popups/PopupTerms.vue